<template>
  <div class="membership-select">
    <v-select :items="items" item-value="text" v-model="item" @input="selected"></v-select>
  </div>
</template>

<script>
export default {
  name: 'membership-select',
  components: {},
  props: ['items'],

  data() {
    return {
      item: 0,
    };
  },

  mounted() {
    if (localStorage.getItem('activeMember') === null) {
      localStorage.setItem(
        'activeMember',
        JSON.stringify(
          this.items.find((membership) => {
            return membership.type === 'player';
          })
        )
      );
    }

    if (localStorage.getItem('activeMember') !== 'undefined') {
      const activeMember = JSON.parse(localStorage.getItem('activeMember'));

      this.item = activeMember.text;

      // TODO: remove
      this.item = 'E6Golf';
    }
  },

  methods: {
    selected(newValue) {
      const activeMembership = this.items.find((membership) => {
        return membership.text === newValue;
      });

      localStorage.setItem('activeMember', JSON.stringify(activeMembership));

      switch (activeMembership.type) {
        case 'player':
          this.$router.push('/dashboard');
          break;
        case 'clubhouseOwner':
          this.$router.push(`/clubhouses/${activeMembership.id}/dashboard`);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.membership-select {
  display: flex;
}
</style>
